/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (UpgradeBase, WidgetUpgradeUtils) => {

	/**
	 * Upgrade VIDA property. Replace the `bar.padding` property with the `bar.relativePadding` property.
	 * Ensure the previous boolean property value is converted to either 0.1 (true) or 0 (false).
	 */
	class VIDARelativePaddingPropUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 2003;
		}

		/**
		 * Perform upgrade
		 * @param {object} spec - spec to perform upgrade on
		 * @return {Promise} Promise resolved when upgrade step is complete
		 */
		up(spec) {
			if (WidgetUpgradeUtils.specHasWidgets(spec)) {
				for(const widgetId in spec.widgets) {
					const widget = spec.widgets[widgetId];
					if (widget && WidgetUpgradeUtils.isLiveWidgetModel(widget)) {
						this.upgradeProperties(widget.properties || []);
					}
				}
			}
			return Promise.resolve(spec);
		}

		upgradeProperties(properties) {
			const deprecatedProp = WidgetUpgradeUtils.findProperty('bar.padding', properties);
			if (deprecatedProp) {
				// `bar.padding`: true is equivalent to `bar.relativePadding`: 0.1
				// `bar.padding`: false is equivalent to `bar.relativePadding`: 0
				deprecatedProp.id = 'bar.relativePadding';
				deprecatedProp.value = (deprecatedProp.value === true) ? 0.1 : 0;
			}
		}
	}

	return new VIDARelativePaddingPropUpgrade();
});
